<ng-container *ngrxLet="isSmallTablet() as isSmallTablet">
	<div
		[excludeFromClosingRegex]="excludeFromClosingRegex"
		[ngClass]="{ 'flex h-full': fullHeightContainer }"
		(clickOutside)="hide()"
		vc-click-outside
	>
		<ng-content />
		<div
			[id]="popoverId"
			[ngClass]="[
				showPopover ? 'visible' : 'hidden',
				isSmallTablet
					? '!fixed !left-0 !w-full !transform-none transition-sheet duration-500'
					: '',
				showPopover && isSmallTablet
					? '!top-16'
					: !showPopover && isSmallTablet
						? '!top-[150%]'
						: '',
				isFullHeight && isSmallTablet ? '!h-[calc(100%-64px)]' : '',
				!isFullHeight && isSmallTablet
					? '!bottom-0 !top-[unset] h-auto'
					: '',
			]"
			class="!-bottom-0 !top-[unset] z-30 !h-fit max-h-screen w-fit md:!top-0"
			data-test-id="popover"
		>
			<div
				#popoverContent
				[class]="className"
				[ngClass]="{
					hidden: isSSRMode,
					'w-full': isSmallTablet,
				}"
				class="card card-no-padding h-fit w-full overflow-visible rounded-none md:card md:card-no-padding"
			>
				@if ((showHeader && closeable) || isSmallTablet) {
					<div
						class="card-md border-b border-b-ui-100 md:border-none md:pb-0"
					>
						<div class="flex justify-between">
							<div #headerRef class="w-full">
								<ng-content select="vp-popover-header-title" />
							</div>

							@if (closeable || isSmallTablet) {
								<button (click)="toggle()" class="size-5">
									<span class="sr-only">{{
										'global.close' | translate
									}}</span>
									<svg-icon
										class="size-5 cursor-pointer"
										src="assets/icons/icon-cross.svg"
									/>
								</button>
							}
						</div>
					</div>
				}
				<div
					[ngClass]="{
						'block overflow-y-auto': isSmallTablet,
					}"
					[style.max-height]="
						isSmallTablet ? mainContentHeight : 'auto'
					"
				>
					<ng-content select="vp-popover-content" />
				</div>
				<div
					#footer
					[ngClass]="{
						'card-md border-t border-t-ui-100 md:border-none':
							footer.children[0]?.children?.length,
					}"
					class="md:hidden"
				>
					<ng-content select="vp-popover-footer" />
				</div>
			</div>
		</div>
	</div>
	<div
		[ngClass]="{
			'overlay-dark-3 fixed left-0 top-0 z-20 size-full':
				showPopover && isSmallTablet,
		}"
		class="transition-colors"
	></div>
</ng-container>
